import React from 'react';
import { Col, Row } from 'antd';
import ProductCount from '../components/analytics/product-count';
import ProductList from '../components/product/list';
import ProductTodoList from '../components/product/todo-list';
import MassUploadPending from '../components/product/massupload-pending';

class ProductPage extends React.Component{

	render(){
		return (
			<Row style={{ margin: 8 }} gutter={8}>
				<Col span={8}>
					<ProductCount />

					<ProductTodoList />
					
				</Col>
				<Col span={16}>
					<ProductList/>

					<MassUploadPending />
				</Col>
			</Row>
		)
	}

}

export default ProductPage;


// WEBPACK FOOTER //
// ./src/containers/product-page.js